export function generateSlug(name: string | null): string {
  if (!name) {
    return ""
  }

  let slug = name.replace(/['".,\/#!$%\^&\*;:{}=\-`~()]/g, "")
  // Modified regex to exclude numbers from being replaced
  slug = slug.replace(/[^\w\d]+/g, "_").toLowerCase()
  slug = slug.replace(/^_+|_+$/g, "")

  return slug
}
